<template>
  <div class="d-inline-block">
    <div class="membership_manage_setting">
      <div class="mt-8">
        <div class="d-inline-flex align-center mb-3">
          <p class="mb-0 mt-1 title font-weight-bold">
            쇼핑몰 멤버십 관리 페이지 설정
          </p>
          <v-btn
            depressed
            small
            color="#424242"
            class="font-weight-black mr-0 white--text ml-7 mb-0 mt-1"
            aling="left"
            @click="exampleViewPage()"
            >예제화면</v-btn
          >
        </div>

        <v-row class="pt-0 pb-0 mt-1 ml-0 mr-0 mb-3 " width="1108">
          <div
            style="background-color: rgb(248, 248, 248); width:1108px;"
            class="pa-7"
          >
            <p class="font-weight-bold body-1 black--text mb-2">
              설정하신 멤버십 혜택 내역을 참고하세요.
            </p>
            <p
              v-if="membership_info.ship_benefits == 'T'"
              class="membershipSettingTextInfo mb-0 float-left"
              style="width:350px;"
            >
              ㆍ 무료 배송 제공
            </p>
            <p
              v-if="membership_info.discount_information.amount_discount > 0"
              class="membershipSettingTextInfo mb-0 float-left"
              style="width:350px;"
            >
              ㆍ 구매시
              {{ membership_info.discount_information.amount_discount | comma
              }}<!-- 공백 제거용 주석
                    -->{{
                membership_info.discount_information.discount_unit
                  | percentWonUnitConversion
              }}
              할인
            </p>
            <p
              v-if="membership_info.points_information.amount_discount > 0"
              class="membershipSettingTextInfo mb-0  float-left"
              style="width:350px;"
            >
              ㆍ 구매시 적립금
              {{ membership_info.points_information.amount_discount | comma
              }}<!-- 공백 제거용 주석
                    -->{{
                membership_info.points_information.discount_unit
                  | percentWonUnitConversion
              }}
              지급
            </p>
            <p
              v-if="
                membership_info.mobile_discount_information.amount_discount > 0
              "
              class="membershipSettingTextInfo mb-0  float-left"
              style="width:350px;"
            >
              ㆍ 모바일 구매시 추가
              <font>
                {{
                  membership_info.mobile_discount_information.amount_discount
                    | comma
                }}<!-- 공백 제거용 주석
                    --></font
              >
              <font
                v-if="
                  membership_info.mobile_discount_information.discount_unit ==
                    'W'
                "
                >원</font
              >
              <font v-else>%</font>
              할인
            </p>

            <p
              v-if="
                membership_info.mobile_points_information.amount_discount > 0
              "
              class="membershipSettingTextInfo mb-0 float-left"
              style="width:350px;"
            >
              ㆍ 모바일 구매시 추가 적립금
              {{
                membership_info.mobile_points_information.amount_discount
                  | comma
              }}<!-- 공백 제거용 주석
                    --><font
                v-if="
                  membership_info.mobile_points_information.discount_unit == 'W'
                "
                >원</font
              >
              <font v-else>%</font>

              지급
            </p>
            <p
              v-if="membership_info.coupon_info.length > 0"
              class="membershipSettingTextInfo mb-0 float-left"
              style="width:350px;"
            >
              ㆍ 멤버십 회원 전용 쿠폰
              {{ membership_info.coupon_info.length }}개 지급
            </p>
            <p
              v-if="membership_info.total_point > 0"
              class="membershipSettingTextInfo mb-0 float-left"
              style="width:350px;"
            >
              ㆍ 멤버십 회원 전용 적립금
              {{ membership_info.total_point | comma }}원 지급
            </p>
            <p
              v-if="membership_info.category_info.length > 0"
              class="membershipSettingTextInfo mb-0 float-left"
              style="width:350px;"
            >
              ㆍ 멤버십 회원 전용 상품 제공
            </p>
          </div>
        </v-row>

        <v-card width="1108" outlined class="pt-0">
          <div class="d-flex">
            <v-card-text
              class="pa-0 d-flex align-center"
              style="max-width:220px; background-color:#f0f7ff; height:70px;"
            >
              <div class="float-left">
                <p
                  style="font-size: 1rem;"
                  class="mb-0 mt-0 ml-5 font-weight-medium black--text"
                >
                  상단 멤버십 아이콘
                </p>
              </div>
            </v-card-text>
            <v-card-text class="pa-0 d-flex ml-5" style="align-items: center;">
              <div class="float-left">
                <div style="align-items: center;display: flex;">
                  <v-avatar class="float-left mt-0 mb-0" size="60">
                    <img
                      :src="mall_benefit_part.benefit_image"
                      @error="getDefaultImage"
                    />
                  </v-avatar>
                  <v-btn
                    depressed
                    small
                    color="#2196f3"
                    class="font-weight-black mr-0 white--text ml-5 mb-0 mt-0  float-left"
                    aling="left"
                    @click="showImageUpload()"
                    >+ 등록</v-btn
                  >
                  <p
                    class="mb-0 ml-3"
                    style="font-size:15px ; color:rgba(0, 0, 0, 0.6) !important;"
                  >
                    권장이미지 : 125px * 125px / 5M 이하 / gif, png, jpg(jpeg)
                  </p>
                </div>
              </div>
            </v-card-text>
          </div>
          <v-divider></v-divider>
          <div class="d-flex">
            <v-card-text
              class="pa-0 d-flex align-center"
              style="max-width:220px; background-color:#f0f7ff; height:50px;"
            >
              <div class="float-left">
                <p
                  style="font-size: 1rem;"
                  class="mb-0 mt-0 ml-5 font-weight-medium black--text"
                >
                  멤버십 혜택 문구
                </p>
              </div>
            </v-card-text>
            <v-card-text class="pa-0  d-inline-flex align-center ml-5">
              <div class="float-left d-inline-flex align-center">
                <v-text-field
                  v-model="mall_benefit_part.benefit_title"
                  outlined
                  class="mt-0 mb-0"
                  hide-details
                  dense
                  style="width:540px;"
                  placeholder="ex) 회원님이 누리고 있는 혜택"
                ></v-text-field>
              </div>
            </v-card-text>
          </div>
          <v-divider></v-divider>

          <div class="d-flex">
            <v-card-text
              class="pa-0"
              style="max-width:220px; background-color:#f0f7ff;"
            >
              <div class="float-left">
                <p
                  style="font-size: 1rem;"
                  class="mb-3 mt-5 ml-5 font-weight-medium black--text"
                >
                  멤버십 혜택 목록
                </p>
              </div>
            </v-card-text>
            <v-card-text class="pa-0 ml-5">
              <div class="float-left" style="width: 845px;">
                <div class="mt-3 mb-3">
                  <v-data-table
                    :headers="headers"
                    :items="mall_benefit_part.benefits"
                    item-key="icon_image"
                    class="elevation-1 memberMansgeTable"
                    hide-default-footer
                    no-data-text="내역이 없습니다."
                    item-class="align-center"
                    mobile-breakpoint="0"
                  >
                    >
                    <template v-slot:[`item.image`]="{ item }">
                      <v-avatar class=" mt-0 mb-0" size="40">
                        <img :src="item.image" @error="getDefaultImage" />
                      </v-avatar>
                    </template>
                    <template v-slot:[`item.title`]="{ item }">
                      <p
                        class="mb-0 text-center body-2 hover hoverPrimaryText"
                        @click="updateBenefit(item)"
                      >
                        {{ item.title }}
                      </p>
                    </template>
                    <template v-slot:[`item.use_detail`]="{ item }">
                      <p class="mb-0  text-center body-2">
                        {{
                          item.use_detail == "enabled" ? "사용함" : "사용안함"
                        }}
                      </p>
                    </template>
                    <template v-slot:[`item.benefit_id`]="{ item }">
                      <v-btn
                        depressed
                        small
                        color="#EEEEEE"
                        class="mr-0 black--text mb-0 mt-0"
                        aling="left"
                        @click="deleteBenefit(item)"
                        >삭제</v-btn
                      >
                    </template>
                  </v-data-table>
                </div>
                <v-btn
                  depressed
                  small
                  color="black"
                  class="font-weight-black mr-0 white--text mb-3 mt-0  float-left"
                  aling="left"
                  @click="showBenefitModal()"
                  >+ 혜택 내역 등록</v-btn
                >
              </div>
            </v-card-text>
          </div>

          <v-divider></v-divider>
          <div class="d-flex">
            <v-card-text
              class="pa-0 d-flex align-center"
              style="max-width:220px; background-color:#f0f7ff;"
            >
              <div class="float-left">
                <p
                  style="font-size: 1rem;"
                  class="mb-0 mt-3 ml-5 font-weight-medium black--text"
                >
                  멤버십 해지 페이지
                </p>
                <p
                  style="font-size: 1rem;"
                  class="mb-0 mt-1 ml-5 font-weight-medium black--text"
                >
                  하단 안내 문구
                </p>
              </div>
            </v-card-text>
            <v-card-text class="pa-0  d-inline-flex align-center ml-5">
              <div class="float-left d-inline-flex align-center">
                <v-text-field
                  v-model="mall_benefit_part.benefit_cancel_guide.title"
                  outlined
                  class="mt-0 mb-0"
                  hide-details
                  dense
                  style="width:540px;"
                  placeholder="멤버십 해지시 정책 안내"
                ></v-text-field>

                <p
                  class="mb-0 ml-3"
                  style="font-size:15px ; color:rgba(0, 0, 0, 0.6) !important;"
                >
                  타이틀을 입력합니다.
                </p>
              </div>
            </v-card-text>
          </div>
          <div class="d-flex">
            <v-card-text
              class="pa-0 d-flex align-center"
              style="max-width:220px; background-color:#f0f7ff;"
            >
            </v-card-text>
            <v-card-text class="pa-0  d-inline-flex align-center ml-5">
              <div
                class="float-left d-inline-flex align-center mb-3"
                style="width: 846px;"
              >
                <v-textarea
                  v-model="mall_benefit_part.benefit_cancel_guide.contents"
                  outlined
                  no-resize
                  style="width:540px; font-size: 16px;"
                  height="180"
                  hide-details
                  placeholder="멤버십 해지시 정책 안내 내용"
                ></v-textarea>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </div>

      <div class="mt-5 mb-8 float-left">
        <v-btn
          color="#9b59b6"
          class="white--text mr-3"
          width="220"
          depressed
          right
          align="left"
          @click="membershipManageMove()"
          :disabled="showBenefit"
          >멤버십 설정 목록으로 이동</v-btn
        >
      </div>
      <div class="mt-5 mb-8 float-right">
        <v-btn
          color="#8292ff"
          class="white--text mr-3"
          width="220"
          depressed
          right
          align="right"
          @click="previewMove()"
          :disabled="showBenefit"
          >쇼핑몰 적용 화면 미리보기</v-btn
        >
        <v-btn
          color="primary"
          width="350"
          depressed
          right
          align="right"
          @click="membershipBenefitSettingSave()"
          >저장하기</v-btn
        >
      </div>
    </div>
    <BenefitSetting ref="BenefitSetting"></BenefitSetting>
    <BenefitSettingUpdate ref="BenefitSettingUpdate"></BenefitSettingUpdate>
    <ImageUpload ref="ImageUpload"></ImageUpload>
    <ProgressDialog ref="ProgressDialog"></ProgressDialog>
  </div>
</template>

<style>
.theme--light.v-color-picker span {
  display: none;
}
.theme--light.v-color-picker .v-color-picker__input input {
  margin-bottom: 0px;
}
</style>

<script>
import CommonMixin from "@/mixins/CommonMixin.js";
import M from "@/libs/mapping.js";
import Filters from "@/libs/membership/filters.js";
import FileReader from "@tanker/file-reader";

const BenefitSetting = () =>
  import(
    /* webpackChunkName: "BenefitSetting" */ "@/components/membership/membership_manage/modal/BenefitSetting.vue"
  );
const BenefitSettingUpdate = () =>
  import(
    /* webpackChunkName: "BenefitSettingUpdate" */ "@/components/membership/membership_manage/modal/BenefitSettingUpdate.vue"
  );
const ImageUpload = () =>
  import(
    /* webpackChunkName: "ImageUpload" */ "@/components/membership/membership_manage/modal/ImageUpload.vue"
  );
const ProgressDialog = () =>
  import(
    /* webpackChunkName: "ProgressDialog" */ "@/components/membership/membership_manage/modal/ProgressDialog.vue"
  );

export default {
  data: () => ({
    M,
    background_type: "hexa",
    background_hexa: "#FF00FFFF",
    text_type: "hexa",
    text_hexa: "#FF00FFFF",
    icon_type: "hexa",
    icon_hexa: "#FF00FFFF",
    items: [
      {
        icon_image: "https://cdn.vuetifyjs.com/images/john.jpg",
        benefit_title: "주문시 무료 배송",
        detail_info_setting: "사용함",
        delete: "삭제",
      },
    ],
    headers: [
      {
        text: "아이콘이미지",
        align: "center",
        value: "image",
        sortable: false,
        class: "body-2",
      },
      {
        text: "혜택 타이틀",
        value: "title",
        sortable: false,
        align: "center",
        class: "body-2",
      },
      {
        text: "상세내역 설정",
        value: "use_detail",
        sortable: false,
        align: "center",
        class: "body-2",
      },
      {
        text: "삭제",
        value: "benefit_id",
        sortable: false,
        align: "center",
        class: "body-2",
      },
    ],
    mall_show_part: {
      membership_id: "",
      product_image: "",
      product_detail_image: "",
      button_text: "",
      button_bg_color: "",
      button_text_color: "",
      bottom_button_bg: "",
    },
    product_image: [],
    product_detail_image: [],
    mall_benefit_part: {
      membership_id: "",
      benefit_title: "",
      benefit_image: "",
      benefits: [
        {
          benefit_id: "1",
          title: "주문시 무료 배송",
          image: "https://cdn.vuetifyjs.com/images/john.jpg",
          detail: "상세내역",
          use_detail: "enabled",
        },
      ],
      benefit_cancel_guide: {
        title: null,
        contents: null,
      },
    },
    membership_info: {
      membership_id: "",
      membership_name: "",
      membership_price: 0,
      use_discount: "",
      subscription_shipments_cycle: "",
      group_no: "",
      group_name: "",
      // 무료배송
      ship_benefits: "",
      //구매할인
      discount_information: {
        amount_product: 0,
        amount_discount: 0,
        discount_unit: "",
      },
      //모바일 추가 할인
      mobile_discount_information: {
        amount_product: 0,
        amount_discount: 0,
        discount_unit: "",
      },
      //구매 적립금 지급
      points_information: {
        amount_product: 0,
        amount_discount: 0,
        discount_unit: "",
      },
      //모바일 추가 적립
      mobile_points_information: {
        amount_product: 0,
        amount_discount: 0,
        discount_unit: "",
      },
      coupon_info: [
        {
          coupon_no: "",
          coupon_issued_type: "",
          coupon_subscription: "",
        },
      ],
      revert_coupon: "",
      point_info: [
        {
          point: 0,
          point_issued_type: "",
          point_subscription: "",
        },
      ],
      revert_point: "",
      category_info: [
        {
          category_no: "",
          category_product_count: "",
        },
      ],
      membership_status: "",
    },
    membership_id: 0,
    product_no: 0,
    showDlsplayDetail: true,
    showBenefit: true,
    uploadButtonDisable: true,
    uploadDetailButtonDisable: true,
  }),
  methods: {
    showBenefitModal: async function() {
      this.$refs.BenefitSetting.show(this.membership_info);
    },
    membershipSettingSave: async function() {
      if (!this.product_image) {
        alert("상품 이미지를 등록해 주세요.");
        return false;
      }
      if (!this.product_image.name && !this.mall_show_part.product_image) {
        alert("상품 이미지를 등록해 주세요.");
        return false;
      }

      if (this.product_image.name && !this.mall_show_part.product_image) {
        alert("상품 이미지를 업로드해주세요.");
        return false;
      }

      /*
      if (!this.product_detail_image) {
        alert("상세 설명 이미지를 등록해 주세요.");
        return false;
      }
      if (
        !this.product_detail_image.name &&
        !this.mall_show_part.product_detail_image
      ) {
        alert("상세 설명 이미지를 등록해 주세요.");
        return false;
      }
*/

      if (
        this.product_detail_image.name &&
        !this.mall_show_part.product_detail_image
      ) {
        alert("상세 설명 이미지를 업로드해주세요.");
        return false;
      }

      if (!this.mall_show_part.button_text) {
        alert("하단 버튼 타이틀을 입력해 주세요");
        return false;
      }

      try {
        await M.api(
          M.entry("/put/membership/display", this.mall_show_part.membership_id),
          this.mall_show_part
        );
        this.showDlsplayDetail = false;
        alert("저장되었습니다.");
      } catch (e) {
        alert("저장 실패했습니다.");
      }
    },
    membershipBenefitSettingSave: async function() {
      if (!this.mall_benefit_part.benefit_image) {
        alert("상단 멤버십 아이콘을 등록해 주세요");
        return false;
      }

      if (!this.mall_benefit_part.benefit_title) {
        alert("멤버십 혜택 문구를 입력해 주세요");
        return false;
      }

      if (this.mall_benefit_part.benefits <= 0) {
        alert("멤버십 혜택 목록을 입력해 주세요");
        return false;
      }

      if (this.mall_benefit_part.benefit_cancel_guide.title <= 0) {
        alert("멤버십 해지 페이지 타이틀을 입력해 주세요");
        return false;
      }

      if (this.mall_benefit_part.benefit_cancel_guide.contents <= 0) {
        alert("멤버십 해지 페이지 내용을 입력해 주세요");
        return false;
      }

      // this.$refs.ProgressDialog.show();

      try {
        await M.api(
          M.entry(
            "/put/membership/benefits",
            this.mall_benefit_part.membership_id
          ),
          this.mall_benefit_part
        );
        this.showBenefit = false;
        this.$parent.step3_complete = true;
        alert("저장되었습니다.");
      } catch (e) {
        alert("저장 실패했습니다.");
      }
      // this.$refs.ProgressDialog.hide();
    },

    showProductImageUrl: function() {
      let newTab = window.open();
      newTab.document.body.innerHTML =
        '<div><img src="' + this.mall_show_part.product_image + '" ></div>';
    },

    showImageUrl: function() {
      let newTab = window.open();
      newTab.document.body.innerHTML =
        '<div><img src="' +
        this.mall_show_part.product_detail_image +
        '" ></div>';
    },

    cancelProductImage: function() {
      this.mall_show_part.product_image = null;
      this.product_image = null;
      this.uploadButtonDisable = true;
    },

    cancelProductDetailImage: function() {
      this.mall_show_part.product_detail_image = null;
      this.product_detail_image = null;
      this.uploadDetailButtonDisable = true;
    },

    uploadProductImageChange: async function() {
      let maxSize = 5 * 1024 * 1024; //5MB

      if (this.product_image) {
        if (this.product_image.size >= maxSize) {
          this.product_image = [];
          this.uploadButtonDisable = true;
          alert("이미지 용량을 줄여주세요.");
          return false;
        }

        this.uploadButtonDisable = false;
      } else {
        this.uploadButtonDisable = true;
      }
    },

    getImageSize: async function(image) {
      let _URL = window.URL || window.webkitURL;
      let objectUrl = _URL.createObjectURL(image);
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = () =>
          resolve({
            width: img.width,
            height: img.height,
          });
        img.onerror = reject;
        img.src = objectUrl;
      });
    },

    uploadProductImage: async function() {
      let fileInfo = document.getElementById("product_image").files[0];
      if (!fileInfo) {
        alert("상품 이미지를 등록해주세요.");
        return false;
      }
      const reader = new FileReader(fileInfo);
      const dataUrl = await reader.readAsDataURL();
      this.mall_show_part.product_image = dataUrl;

      alert("업로드 되었습니다");
    },
    uploadProductDetailImageChange: async function() {
      let maxSize = 5 * 1024 * 1024; //5MB

      if (this.product_detail_image) {
        let getImageSize = await this.getImageSize(this.product_detail_image);
        if (getImageSize.width != 750) {
          this.product_detail_image = [];
          this.uploadDetailButtonDisable = true;
          alert("넓이 750px으로 맞춰주세요.");
          return false;
        }

        if (this.product_detail_image.size >= maxSize) {
          this.product_detail_image = [];
          this.uploadDetailButtonDisable = true;
          alert("이미지 용량을 줄여주세요.");
          return false;
        }

        this.uploadDetailButtonDisable = false;
      } else {
        this.uploadDetailButtonDisable = true;
      }
    },
    stateChange: async function(product_image_status) {
      this.product_image_status = product_image_status;
    },
    uploadProductDetailImage: async function() {
      let fileInfo = document.getElementById("product_detail_image").files[0];
      if (!fileInfo) {
        alert("상세 설명 이미지를 등록해주세요.");
        return false;
      }
      const reader = new FileReader(fileInfo);

      // Read the whole file
      const dataUrl = await reader.readAsDataURL();
      this.mall_show_part.product_detail_image = dataUrl;

      alert("업로드 되었습니다");
    },
    getMemebership: async function(membership_id) {
      try {
        let result = await M.api(M.entry("/get/membership", membership_id));
        this.membership_info = result;

        if (result.point_info.length > 0) {
          let total_point = 0;
          for (let i = 0; i < result.point_info.length; i++) {
            total_point += result.point_info[i].point;
          }
          this.membership_info.total_point = total_point;
        }

        this.product_no = result.product_no;
      } catch (e) {
        //alert("저장 실패했습니다.");
      }
    },
    getDefaultImage: function(event) {
      event.target.src = "/membership/image/default_image.png";
    },
    showImageUpload: function() {
      this.$refs.ImageUpload.show();
    },
    getMembershipProductPage: async function(membership_id) {
      try {
        let result = await M.api(
          M.entry("/get/membership/display", membership_id)
        );

        this.mall_show_part = result;

        if (
          result.membership_id &&
          //result.product_image &&
          //result.product_detail_image &&
          result.button_text &&
          result.button_bg_color &&
          result.button_text_color &&
          result.bottom_button_bg
        ) {
          this.showDlsplayDetail = false;
        } else {
          this.showDlsplayDetail = true;
        }
      } catch (e) {
        //console.log(e);
      }
    },
    getMembershipBenefitPage: async function(membership_id) {
      try {
        let result = await M.api(
          M.entry("/get/membership/benefits", membership_id)
        );

        this.mall_benefit_part = result;

        if (
          result.membership_id &&
          result.benefit_title &&
          result.benefit_image &&
          result.benefits.length > 0
        ) {
          this.showBenefit = false;
          this.$parent.step3_complete = true;
        } else {
          this.showBenefit = true;
          this.$parent.step3_complete = false;
        }
      } catch (e) {
        //console.log(e);
      }
    },
    deleteBenefit: function(params) {
      if (confirm("입력하신 멤버십 혜택 내역을\n삭제하시겠습니까?")) {
        const index = this.mall_benefit_part.benefits.indexOf(params);
        this.mall_benefit_part.benefits.splice(index, 1);
      }
    },
    membershipManageMove: function() {
      this.$router.push({
        path: `/membership/${this.$store.state.mallId}/membershipManage`,
      });
    },

    updateBenefit: function(params) {
      this.$refs.BenefitSettingUpdate.show(params);
    },

    previewMove: function() {
      let preview_url = `https://${this.$store.state.mallId}.cafe24.com/shoplus/membership/src/membership_manage.html?mall_id=${this.$store.state.mallId}&product_no=${this.product_no}&view=1`;
      let win = window.open(preview_url, "_blank");
      win.focus();
    },
    exampleViewPage: function() {
      let newTab = window.open();
      newTab.document.title = "멤버십 예제화면2";
      newTab.document.body.innerHTML =
        '<div><img src="https://surping1.cafe24.com/appstore/membership_ex2.jpg" ></div>';
    },
  },
  mixins: [CommonMixin],
  filters: Filters,
  components: {
    BenefitSetting,
    BenefitSettingUpdate,
    ImageUpload,
    ProgressDialog,
  },
  beforeCreate: function() {
    this.$parent.$parent.progressShow();
  },
  created: async function() {
    this.mall_id = this.$store.state.mallId;
    let query = this.$route.query;
    if (query) {
      if (query.membership_id) {
        //조회
        await this.getMemebership(query.membership_id);
        await this.getMembershipProductPage(query.membership_id);
        await this.getMembershipBenefitPage(query.membership_id);
        this.$parent.$parent.progressHide();
      }
    }
  },
};
</script>
